import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { LogisticsContext } from "context/LogisticsContext";
import { UserContext } from "context/UserContext";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LogisticsDetailContent from "components/LogisticsDetailContent";

function Logistics() {
  const { user, loading: userLoading } = useContext(UserContext);
  const { fetchLogisticsData } = useContext(LogisticsContext);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedLogistics, setSelectedLogistics] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const getData = useCallback(async () => {
    if (!user) {
      return;
    }

    setIsLoading(true);
    try {
      const data = await fetchLogisticsData("ROLE_ACCOUNTANT");
      setRows(data.rows || []);
      setColumns(
        (data.columns || []).map((col) => ({
          ...col,
          flex: col.flex || 1,
          minWidth: col.minWidth || col.width || 120,
        }))
      );
    } catch (error) {
      toast.error("Veri yüklenirken hata oluştu", { position: "top-right" });
    } finally {
      setIsLoading(false);
    }
  }, [user, fetchLogisticsData]);

  useEffect(() => {
    if (!userLoading && user) {
      getData();
    }
  }, [userLoading, user, getData]);

  const handleRowClick = (params) => {
    setSelectedId(params.id);
    setSelectedLogistics(params.row.fullData || null);
    setDetailOpen(true);
  };

  if (userLoading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <MDTypography variant="h6" color="text">
            Yükleniyor...
          </MDTypography>
        </MDBox>
      </DashboardLayout>
    );
  }

  if (!userLoading && !user) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container justifyContent="flex-start" sx={{ width: "100%" }}>
          <Grid item xs={12} md={12} lg={12}>
            <Card sx={{ borderRadius: 3, boxShadow: 3, marginRight: 2 }}>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Lojistik
                </MDTypography>
              </MDBox>
              <CardContent>
                <DataGrid
                  autoHeight
                  rows={rows}
                  columns={columns}
                  loading={isLoading}
                  disableRowSelectionOnClick
                  onRowClick={handleRowClick}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { debounceMs: 400 },
                    },
                  }}
                  localeText={{
                    toolbarColumns: "Sütunlar",
                    toolbarFilters: "Filtreler",
                    toolbarExport: "Dışa Aktar",
                    toolbarDensity: "Yoğunluk",
                    toolbarQuickFilterPlaceholder: "Ara...",
                    noRowsLabel: "Gösterilecek lojistik bulunamadı",
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Dialog open={detailOpen} onClose={() => setDetailOpen(false)} fullWidth maxWidth="md">
          <DialogTitle sx={{ pb: 0 }}>
            <MDTypography variant="h5" fontWeight="bold">
              Lojistik Detayı
            </MDTypography>
            <MDTypography variant="button" color="text" sx={{ opacity: 0.8 }}>
              #{selectedId ?? "-"}
            </MDTypography>
          </DialogTitle>
          <DialogContent dividers>
            <LogisticsDetailContent logistics={selectedLogistics} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDetailOpen(false)}>Kapat</Button>
          </DialogActions>
        </Dialog>
      </MDBox>
    </DashboardLayout>
  );
}

export default Logistics;
